import { render, staticRenderFns } from "./CoinsPurchasedHistoryList.vue?vue&type=template&id=7e19dd1b&scoped=true&"
import script from "./CoinsPurchasedHistoryList.vue?vue&type=script&lang=ts&"
export * from "./CoinsPurchasedHistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsPurchasedHistoryList.vue?vue&type=style&index=0&id=7e19dd1b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e19dd1b",
  null
  
)

export default component.exports